import { render, staticRenderFns } from "./doctor-list.vue?vue&type=template&id=1756e829&scoped=true&"
import script from "./doctor-list.vue?vue&type=script&lang=js&"
export * from "./doctor-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1756e829",
  null
  
)

export default component.exports